import type { QueryClient } from "@tanstack/react-query";

import {
  createPurchasePayinConfig,
  fetchPatientShopCatalog,
  fetchShopCatalog,
} from "@/api/shop/shop";

export const shopQueryKeys = {
  catalog: (tenantSlug: string, patientId?: string | null) =>
    ["shop", tenantSlug, "catalog", { patientId: patientId ?? null }] as const,
};

export const shopQueryOptions = {
  catalog: (tenantSlug: string, patientId?: string | null) => ({
    queryKey: shopQueryKeys.catalog(tenantSlug, patientId),
    queryFn: patientId ? fetchPatientShopCatalog : fetchShopCatalog,
  }),
};

export const refetchShopCatalogQuery = (
  queryClient: QueryClient,
  tenantSlug: string,
  patientId?: string | null,
) =>
  queryClient.refetchQueries(
    {
      queryKey: shopQueryKeys.catalog(tenantSlug, patientId),
      exact: true,
      type: "active",
    },
    { throwOnError: true },
  );

export const shopMutationOptions = {
  createPayinConfig: () => ({
    mutationFn: createPurchasePayinConfig,
  }),
};
